// Originally from Avery (Velara) Avery#9136, modified by me. Included with permission.
import { MODULENAME } from "../../xdy-pf2e-workbench.js";

/**
 * Builds the NPC Spellbook Journal.
 *
 * @return {Promise<void>} Returns a promise that resolves when the journal is created.
 */
export async function buildNpcSpellbookJournal() {
    // @ts-ignore
    const activeWindow = ui.activeWindow;
    let actor;
    if (activeWindow?.constructor.name === "NPCSheetPF2e") {
        actor = activeWindow.token?.actor || activeWindow.actor;
    } else {
        const actors = canvas.tokens.controlled.map((a) => a.actor).filter((a) => a?.isOfType("npc"));
        if (actors?.length === 1) {
            actor = actors[0];
        }
    }

    const spellcastingEntries = actor?.spellcasting?.contents?.filter((item) => item.spells);
    const length = spellcastingEntries?.length;

    if (!actor || length === 0) {
        ui.notifications.warn(game.i18n.localize(`${MODULENAME}.macros.buildNpcSpellbookJournal.noSpellcastingEntry`));
        return;
    }

    const spellList: any[] = [];
    for (let i = 0; i < length; i++) {
        spellList[i] = { entry: spellcastingEntries[i].name, spells: [] };
        for (let ii = 0; ii < spellcastingEntries[i]?.spells?.contents?.length; ii++) {
            spellList[i].spells.push("@UUID[" + spellcastingEntries[i].spells.contents[ii].sourceId + "]");
        }
    }
    let content = `<table class="pf2-table">
<tr>
   <th>Entry</th>
   <th>Spells</th>
</tr>`;

    for (let ff = 0; ff < spellList.length; ff++) {
        content += `
  <tr>
  <td>${spellList[ff].entry}</td>
  <td><div style="display: flex; gap:3px; flex-wrap: wrap; align-items: center;justify-content: center;">${spellList[ff].spells}</div></td>
  </tr>
  `;
    }
    const updates: any = {
        name: game.i18n.format(`xdy-pf2e-workbench.macros.buildNpcSpellbookJournal.generatedSpellbookFor`, {
            name: actor.name,
        }),
        pages: [{ name: "Spell book", text: { content } }],
    };
    updates.content += `</table>`;

    const journal = game.journal.getName(updates.name);
    if (journal) {
        await journal.delete();
    }
    await JournalEntry.create(updates);
}

// await buildSpellbookJournal();
